<div class="item">
    <div class="text-link">
        <a routerLink="{{link()}}">
            <ng-content></ng-content>
        </a>
        <label class="fav" [ngClass]="isFavoriteListItem() ? 'fav-list-item' : ''">
            <input type="checkbox" name="" value="" [checked]="showFavoriteIcon()" (change)="favoriteChange($event)"/>
            <svg fill="currentColor" outline="currentColor" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M0 0h24v24H0z" fill="none"/><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>
        </label>
    </div>
</div>
